module.exports = __webpack_public_path__ + "img/desktop-VTA-domicilio.50cb50de.png";